// removed by extract-text-webpack-plugin
module.exports = {"PageContainer":"StoreList__PageContainer__pRxCB","StoreListContainer":"StoreList__StoreListContainer__2ceZu","Row":"StoreList__Row__3sGWd","StorePopupErrorMessage":"StoreList__StorePopupErrorMessage__CXRNZ","EditBookingLink":"StoreList__EditBookingLink__1IwN_"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/StoreList/StoreList.css
// module id = 120
// module chunks = 0